<div
	class="card-outer-wrapper"
	[class.has-error]="hasError()"
	[class.card--selected]="isSelected()"
	[attr.data-testid]="effectiveTestId()"
	(click)="onCardClick()"
>
	<!-- Debug info -->
	@if (isDebugMode()) {
		<div
			class="debug-info"
			style="
				position: absolute;
				top: 4px;
				left: 4px;
				z-index: 100;
				background: rgba(0, 0, 0, 0.75);
				color: #fff;
				padding: 4px 8px;
				font-size: 10px;
				font-family: 'SF Mono', Monaco, monospace;
				border-radius: 4px;
				backdrop-filter: blur(4px);
				display: flex;
				gap: 8px;
				align-items: center;
			"
		>
			<span style="color: #4fc3f7">{{ cardId() }}</span>
			<span
				style="
					background: #2196f3;
					padding: 1px 6px;
					border-radius: 3px;
					font-size: 9px;
					text-transform: uppercase;
				"
				>table</span
			>
		</div>
	}

	<!-- Top progress bar (refresh or initial load) -->
	@if (showTopProgressBar() && !hasError()) {
		<div class="card-loader">
			<jepto-ui-progress-bar-indeterminate />
		</div>
	}

	<!-- Card header -->
	@if (effectiveTitle() || effectiveSubtitle() || effectiveIcon()) {
		<div class="card-header">
			<div class="card-icon-title-wrapper">
				@if (effectiveIcon()) {
					<mat-icon class="material-symbols-outlined card-icon">{{
						effectiveIcon()
					}}</mat-icon>
				}
				@if (effectiveTitle()) {
					<h2 class="card-title">{{ effectiveTitle() }}</h2>
				}
			</div>
			@if (effectiveSubtitle()) {
				<div class="card-subtitle">{{ effectiveSubtitle() }}</div>
			}
		</div>
	}

	<!-- Error state -->
	@if (hasError()) {
		<jepto-card-query-status
			kind="error"
			noun="table"
			[testId]="effectiveTestId() + '-query-error'"
			(refresh)="onRetry()"
		/>
	}

	<!-- Table content -->
	@if (!isBlockingLoad() && !hasError()) {
		<div class="card-body">
			@if (showCreateTableEmptyState()) {
				<div class="table-create-empty-state">
					<div class="table-create-empty-state__title">Create Table</div>
					<div class="table-create-empty-state__line">
						Pick a dimension under Settings &gt; Data to build your table.
					</div>
					<div class="table-create-empty-state__line">
						Or describe it and let AI do the setup.
					</div>
				</div>
			} @else if (showPageQueryEmptyState()) {
				<jepto-card-query-status
					kind="empty"
					noun="table"
					[testId]="effectiveTestId() + '-query-empty'"
					(refresh)="onRetry()"
				/>
			} @else {
				<div class="jepto-table-card-wrapper">
					<div
						#tableContainer
						class="jepto-table-card-container"
						[class.jepto-table-card-container--wrap-cell-text]="
							wrapCellTextEnabled()
						"
						[style.height]="containerHeightStyle()"
						[style.width]="width()"
					></div>
				</div>
			}
		</div>
	}

	@if (isSelected()) {
		<div class="card-action-buttons">
			<button
				type="button"
				class="card-action-btn"
				aria-label="Edit card"
				(click)="editCard.emit()"
			>
				<span class="icon-edit-2"></span>
			</button>
			<button
				type="button"
				class="card-action-btn"
				aria-label="More options"
				[matMenuTriggerFor]="cardMenu"
				(click)="$event.stopPropagation()"
			>
				<span class="icon-more-vertical"></span>
			</button>
		</div>

		<mat-menu #cardMenu="matMenu" panelClass="card-actions-menu">
			<button mat-menu-item (click)="editCard.emit()">Edit</button>
			<button mat-menu-item (click)="duplicateCard.emit()">
				Duplicate
			</button>
			<button mat-menu-item disabled type="button">Save card</button>
			<button
				mat-menu-item
				class="card-menu-item--danger"
				(click)="deleteCard.emit()"
			>
				Delete
			</button>
		</mat-menu>
	}
</div>
